/**
 * Centre Page gallery: Owl Carousel + Magnific Popup lightbox.
 */
(function ($) {
	'use strict';

	var TABLET_BREAKPOINT = 768;
	var DESKTOP_BREAKPOINT = 1024;
	var DESKTOP_ITEMS = 3;
	var DESKTOP_MARGIN = 8;
	// Same as desktop: stagePadding reads larger than px; /6 ≈ ⅓ of next slide visible.
	var MOBILE_PEEK_DIVISOR = 6;
	var DESKTOP_PEEK_DIVISOR = 6;

	function getResponsiveBase($carousel) {
		return $carousel.closest('.gallery-section__inner');
	}

	/**
	 * Width used for Owl breakpoints — must match responsiveBaseElement, not window.innerWidth.
	 *
	 * @param {jQuery} $carousel Carousel element.
	 * @return {number}
	 */
	function getResponsiveWidth($carousel) {
		var $base = getResponsiveBase($carousel);

		if ($base.length) {
			return $base.width() || 0;
		}

		return document.documentElement.clientWidth || window.innerWidth || 0;
	}

	/**
	 * Width used for slide / peek math (Owl uses the carousel element width).
	 *
	 * @param {jQuery} $carousel Carousel element.
	 * @return {number}
	 */
	function getCarouselMeasureWidth($carousel) {
		var carouselWidth = $carousel.width();

		if (carouselWidth > 0) {
			return carouselWidth;
		}

		return getResponsiveWidth($carousel);
	}

	function getGalleryPeekPadding(carouselWidth, items, margin, peekDivisor) {
		if (carouselWidth < 1) {
			return 0;
		}

		var gaps = margin * (items - 1);
		var itemWidth = (carouselWidth - gaps) / items;

		return Math.round(itemWidth / peekDivisor);
	}

	function getGallerySettingsForBreakpoint(breakpointWidth, measureWidth) {
		if (breakpointWidth < TABLET_BREAKPOINT) {
			return {
				items: 1,
				// Looping, like tablet and desktop: the right-hand peek always has a
				// following slide in it, so the last slide no longer leaves a gap.
				loop: true,
				margin: DESKTOP_MARGIN,
				dots: true,
				stagePadding: getGalleryPeekPadding(
					measureWidth,
					1,
					DESKTOP_MARGIN,
					MOBILE_PEEK_DIVISOR
				),
			};
		}

		if (breakpointWidth < DESKTOP_BREAKPOINT) {
			return {
				items: 2,
				loop: true,
				margin: DESKTOP_MARGIN,
				dots: true,
				stagePadding: 0,
			};
		}

		return {
			items: DESKTOP_ITEMS,
			loop: true,
			margin: DESKTOP_MARGIN,
			dots: true,
			stagePadding: getGalleryPeekPadding(
				measureWidth,
				DESKTOP_ITEMS,
				DESKTOP_MARGIN,
				DESKTOP_PEEK_DIVISOR
			),
		};
	}

	function getActiveGallerySettings($carousel) {
		var responsiveWidth = getResponsiveWidth($carousel);
		var measureWidth = getCarouselMeasureWidth($carousel);

		return getGallerySettingsForBreakpoint(responsiveWidth, measureWidth);
	}

	function applyRightOnlyStagePadding($carousel) {
		var $stage = $carousel.find('.owl-stage');

		if (!$stage.length) {
			return;
		}

		if (getActiveGallerySettings($carousel).stagePadding < 1) {
			$stage.css({
				paddingLeft: '',
				paddingRight: '',
			});
			return;
		}

		$stage.css('padding-left', 0);
	}

	function syncResponsiveOptions($carousel) {
		var owl = $carousel.data('owl.carousel');

		if (!owl || !owl.options.responsive) {
			return;
		}

		var measureWidth = getCarouselMeasureWidth($carousel);

		owl.options.responsive[0] = getGallerySettingsForBreakpoint(0, measureWidth);
		owl.options.responsive[TABLET_BREAKPOINT] = getGallerySettingsForBreakpoint(
			TABLET_BREAKPOINT,
			measureWidth
		);
		owl.options.responsive[DESKTOP_BREAKPOINT] = getGallerySettingsForBreakpoint(
			DESKTOP_BREAKPOINT,
			measureWidth
		);
	}

	function isGalleryVideoPlaying($gallery) {
		return $gallery.find('.gallery-video__player.is-playing').length > 0;
	}

	function updateGalleryStagePadding($carousel) {
		var owl = $carousel.data('owl.carousel');

		if (!owl || isGalleryVideoPlaying($carousel)) {
			return;
		}

		syncResponsiveOptions($carousel);
		$carousel.trigger('refresh.owl.carousel');
		applyRightOnlyStagePadding($carousel);
	}

	function bindGalleryResizeObserver($carousel) {
		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		var $track = getResponsiveBase($carousel);

		if (!$track.length || $carousel.data('galleryResizeObserver')) {
			return;
		}

		var observer = new ResizeObserver(function () {
			syncCarouselWidth($carousel, false);
			updateGalleryStagePadding($carousel);
		});

		observer.observe($track[0]);
		$carousel.data('galleryResizeObserver', observer);
	}

	var magnificSwipeState = null;
	var magnificSwipeSurface = null;
	var MAGNIFIC_SWIPE_THRESHOLD = 40;

	function resetMagnificSwipeState() {
		magnificSwipeState = null;
	}

	function preventMagnificImageDrag(event) {
		event.preventDefault();
	}

	function navigateMagnificGallery(deltaX) {
		var instance = $.magnificPopup.instance;

		if (!instance) {
			return;
		}

		if (deltaX < 0) {
			instance.next();
			return;
		}

		instance.prev();
	}

	function shouldHandleMagnificSwipe(deltaX, deltaY) {
		return Math.abs(deltaX) >= MAGNIFIC_SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY);
	}

	function configureMagnificGalleryLightbox() {
		var wrap = document.querySelector('.mfp-wrap.mfp-centre-gallery');

		if (!wrap) {
			magnificSwipeSurface = null;
			return;
		}

		magnificSwipeSurface = wrap.querySelector('.mfp-container');

		wrap.querySelectorAll('img').forEach(function (image) {
			image.setAttribute('draggable', 'false');
			image.addEventListener('dragstart', preventMagnificImageDrag);
		});
	}

	function onMagnificPointerDown(event) {
		if (!magnificSwipeSurface || event.button > 0) {
			return;
		}

		if (event.target.closest('.mfp-close, .mfp-arrow')) {
			return;
		}

		magnificSwipeState = {
			startX: event.clientX,
			startY: event.clientY,
			pointerId: event.pointerId,
			active: true,
		};

		magnificSwipeSurface.classList.add('mfp-gallery-swipe-dragging');

		if (magnificSwipeSurface.setPointerCapture) {
			try {
				magnificSwipeSurface.setPointerCapture(event.pointerId);
			} catch (error) {
				// Pointer capture is best-effort only.
			}
		}
	}

	function onMagnificPointerMove(event) {
		if (!magnificSwipeState || !magnificSwipeState.active) {
			return;
		}

		if (
			magnificSwipeState.pointerId !== undefined &&
			event.pointerId !== magnificSwipeState.pointerId
		) {
			return;
		}

		var deltaX = event.clientX - magnificSwipeState.startX;
		var deltaY = event.clientY - magnificSwipeState.startY;

		if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
			event.preventDefault();
		}
	}

	function onMagnificPointerEnd(event) {
		if (!magnificSwipeState || !magnificSwipeState.active) {
			return;
		}

		if (
			magnificSwipeState.pointerId !== undefined &&
			event.pointerId !== magnificSwipeState.pointerId
		) {
			return;
		}

		var deltaX = event.clientX - magnificSwipeState.startX;
		var deltaY = event.clientY - magnificSwipeState.startY;

		if (magnificSwipeSurface) {
			magnificSwipeSurface.classList.remove('mfp-gallery-swipe-dragging');

			if (magnificSwipeSurface.releasePointerCapture) {
				try {
					magnificSwipeSurface.releasePointerCapture(event.pointerId);
				} catch (error) {
					// Pointer may already be released.
				}
			}
		}

		resetMagnificSwipeState();

		if (!shouldHandleMagnificSwipe(deltaX, deltaY)) {
			return;
		}

		navigateMagnificGallery(deltaX);
	}

	function bindMagnificGallerySwipe() {
		unbindMagnificGallerySwipe();
		configureMagnificGalleryLightbox();

		if (!magnificSwipeSurface) {
			return;
		}

		magnificSwipeSurface.addEventListener('pointerdown', onMagnificPointerDown);
		magnificSwipeSurface.addEventListener('pointermove', onMagnificPointerMove, { passive: false });
		magnificSwipeSurface.addEventListener('pointerup', onMagnificPointerEnd);
		magnificSwipeSurface.addEventListener('pointercancel', onMagnificPointerEnd);
	}

	function unbindMagnificGallerySwipe() {
		if (magnificSwipeSurface) {
			magnificSwipeSurface.removeEventListener('pointerdown', onMagnificPointerDown);
			magnificSwipeSurface.removeEventListener('pointermove', onMagnificPointerMove);
			magnificSwipeSurface.removeEventListener('pointerup', onMagnificPointerEnd);
			magnificSwipeSurface.removeEventListener('pointercancel', onMagnificPointerEnd);
			magnificSwipeSurface.classList.remove('mfp-gallery-swipe-dragging');
		}

		var wrap = document.querySelector('.mfp-wrap.mfp-centre-gallery');

		if (wrap) {
			wrap.querySelectorAll('img').forEach(function (image) {
				image.removeEventListener('dragstart', preventMagnificImageDrag);
			});
		}

		magnificSwipeSurface = null;
		resetMagnificSwipeState();
	}

	function initMagnificPopup($carousel) {
		if (!$.fn.magnificPopup) {
			return;
		}

		// Bind to Owl's stable root so loop clones created during refreshes inherit
		// the lightbox behaviour through event delegation.
		$carousel.magnificPopup({
			delegate: '.gallery-item__link',
			type: 'image',
			mainClass: 'mfp-fade mfp-centre-gallery',
			removalDelay: 160,
			preloader: false,
			gallery: {
				enabled: true,
				navigateByImgClick: false,
				tPrev: 'Previous image',
				tNext: 'Next image',
			},
			callbacks: {
				open: function () {
					window.requestAnimationFrame(bindMagnificGallerySwipe);
				},
				change: function () {
					window.requestAnimationFrame(configureMagnificGalleryLightbox);
				},
				close: unbindMagnificGallerySwipe,
			},
		});
	}

	/**
	 * Tear down every playing player, optionally sparing one.
	 *
	 * Owl clones the video slide when looping, so more than one player can exist
	 * for the same video. Only ever leave one of them playing.
	 *
	 * @param {jQuery} $gallery Carousel element.
	 * @param {Element} [keep]  Player element to leave untouched.
	 * @return {boolean} Whether anything was torn down.
	 */
	function resetGalleryVideos($gallery, keep) {
		var $playing = $gallery.find('.gallery-video__player.is-playing').filter(function () {
			return this !== keep;
		});

		if (!$playing.length) {
			return false;
		}

		$playing.removeClass('is-playing').find('iframe').remove();

		return true;
	}

	/**
	 * Tear down playback and restore the stage padding skipped while playing.
	 *
	 * @param {jQuery} $gallery Carousel element.
	 * @return {void}
	 */
	function stopGalleryVideos($gallery) {
		if (resetGalleryVideos($gallery)) {
			updateGalleryStagePadding($gallery);
		}
	}

	/**
	 * Drop any poster that fails to load.
	 *
	 * Leaves the player's own black ground and play control rather than a broken
	 * image. Bound per element because error does not bubble, and re-run after
	 * refresh because Owl rebuilds its clones.
	 *
	 * @param {jQuery} $gallery Carousel element.
	 * @return {void}
	 */
	function guardGalleryPosters($gallery) {
		$gallery.find('.gallery-video__poster').each(function () {
			var img = this;

			if (img.getAttribute('data-poster-guarded')) {
				return;
			}

			img.setAttribute('data-poster-guarded', '1');

			if (img.complete && img.naturalWidth === 0) {
				img.parentNode.removeChild(img);
				return;
			}

			img.addEventListener('error', function () {
				if (img.parentNode) {
					img.parentNode.removeChild(img);
				}
			});
		});
	}

	/**
	 * Whether playback has to start muted to begin on the first tap.
	 *
	 * Touch devices refuse autoplay with sound, so the Bunny player falls back to
	 * showing its own play button and the viewer has to tap a second time. Muted
	 * autoplay is permitted, so it starts on one tap and Bunny's own control lets
	 * them unmute. Tests the pointer rather than the viewport, so a narrow desktop
	 * window keeps sound where the browser allows it.
	 *
	 * @return {boolean}
	 */
	function requiresMutedPlayback() {
		return (
			typeof window.matchMedia === 'function' &&
			window.matchMedia('(hover: none) and (pointer: coarse)').matches
		);
	}

	function initGalleryVideo($gallery) {
		if (!$gallery.length || $gallery.data('galleryVideoReady')) {
			return;
		}

		$gallery.data('galleryVideoReady', true);
		guardGalleryPosters($gallery);

		$gallery.on(
			'initialized.owl.carousel.centrePageGalleryVideo refreshed.owl.carousel.centrePageGalleryVideo',
			function () {
				guardGalleryPosters($gallery);
			}
		);

		$gallery.on('click.centrePageGalleryVideo', '.gallery-video__play', function () {
			var $button = $(this);
			var $player = $button.closest('.gallery-video__player');
			var embedUrl = $button.attr('data-video-embed-url');

			if (!embedUrl || $player.hasClass('is-playing')) {
				return;
			}

			// A cloned slide may already be playing the same video.
			resetGalleryVideos($gallery, $player[0]);

			var iframe = document.createElement('iframe');
			var separator = embedUrl.indexOf('?') === -1 ? '?' : '&';

			iframe.src =
				embedUrl +
				separator +
				'autoplay=true&muted=' +
				(requiresMutedPlayback() ? 'true' : 'false') +
				'&preload=true&responsive=true';
			iframe.title = $button.attr('data-video-title') || 'Centre video';
			iframe.allow = 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture';
			iframe.allowFullscreen = true;
			iframe.setAttribute('frameborder', '0');

			$player.addClass('is-playing').append(iframe);

			// The play button is now hidden, so move focus into the player rather
			// than dropping it back to the document.
			if (typeof iframe.focus === 'function') {
				iframe.focus();
			}
		});

		$gallery.on('click.centrePageGalleryVideo', '.owl-dot', function () {
			stopGalleryVideos($gallery);
		});

		// Covers dragging, and any programmatic move the dot handler misses.
		$gallery.on(
			'drag.owl.carousel.centrePageGalleryVideo changed.owl.carousel.centrePageGalleryVideo',
			function () {
				stopGalleryVideos($gallery);
			}
		);

		$gallery.on('resize.owl.carousel.centrePageGalleryVideo', function (event) {
			if (isGalleryVideoPlaying($gallery)) {
				event.preventDefault();
			}
		});
	}

	function syncCarouselWidth($carousel, shouldRefresh) {
		var $track = getResponsiveBase($carousel);

		if (!$track.length) {
			return;
		}

		var width = $track.innerWidth();

		if (width > 0) {
			$carousel.css('width', width + 'px');
		}

		if (shouldRefresh && $carousel.hasClass('owl-loaded')) {
			updateGalleryStagePadding($carousel);
		}
	}

	function initCentrePageGallery(retriesLeft) {
		var $carousel = $('#centre-page-gallery');

		if (!$carousel.length) {
			return;
		}

		initGalleryVideo($carousel);

		if (!$carousel.hasClass('owl-carousel')) {
			return;
		}

		if (typeof $.fn.owlCarousel !== 'function') {
			if (retriesLeft > 0) {
				window.setTimeout(function () {
					initCentrePageGallery(retriesLeft - 1);
				}, 50);
			}
			return;
		}

		if ($carousel.hasClass('owl-loaded')) {
			return;
		}

		var slideCount = $carousel.children('.gallery-slide').length;

		if (slideCount < 2) {
			return;
		}

		var $responsiveBase = getResponsiveBase($carousel);

		syncCarouselWidth($carousel, false);

		var measureWidth = getCarouselMeasureWidth($carousel);
		var initialSettings = getActiveGallerySettings($carousel);
		var mobileSettings = getGallerySettingsForBreakpoint(0, measureWidth);
		var tabletSettings = getGallerySettingsForBreakpoint(TABLET_BREAKPOINT, measureWidth);
		var desktopSettings = getGallerySettingsForBreakpoint(DESKTOP_BREAKPOINT, measureWidth);

		$carousel.owlCarousel({
			responsiveBaseElement: $responsiveBase.length ? $responsiveBase[0] : null,
			items: 1,
			loop: initialSettings.loop,
			margin: DESKTOP_MARGIN,
			dots: initialSettings.dots,
			nav: false,
			autoplay: false,
			smartSpeed: 450,
			dotsEach: true,
			mouseDrag: true,
			touchDrag: true,
			pullDrag: true,
			freeDrag: false,
			stagePadding: initialSettings.stagePadding,
			onInitialized: function () {
				applyRightOnlyStagePadding($carousel);
			},
			onRefreshed: function () {
				applyRightOnlyStagePadding($carousel);
			},
			onResized: function () {
				applyRightOnlyStagePadding($carousel);
			},
			responsive: {
				0: mobileSettings,
				768: tabletSettings,
				1024: desktopSettings,
			},
		});

		$carousel.on('initialized.owl.carousel', function () {
			syncCarouselWidth($carousel, false);
			window.requestAnimationFrame(function () {
				updateGalleryStagePadding($carousel);
			});
		});

		initMagnificPopup($carousel);
		bindGalleryResizeObserver($carousel);

		$(window).on('resize.centrePageGallery', function () {
			syncCarouselWidth($carousel, false);
			updateGalleryStagePadding($carousel);
		});
	}

	$(function () {
		if (!document.body.classList.contains('page-template-centre-page')) {
			return;
		}

		initCentrePageGallery(40);
	});
})(jQuery);
